export default __webpack_public_path__ + "static/pack-673e2ee52a3f75a49e6f80b06bf82a4c.png";